module.exports = __webpack_public_path__ + "static/media/ericsson-1-logo.825505d5.png";